import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { HttpClientModule } from '@angular/common/http';
import { DefaultModule } from './layouts/default/default.module';
import { SharedModule } from './shared/shared.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SupervisorModalComponent } from './modals/supervisor-modal/supervisor-modal.component';
import { QuestionDifficultyModalComponent } from './modals/questiondifficulty-modal/questiondifficulty-modal.component';
import { LevelModalComponent } from './modals/level-modal/level-modal.component';
import { SubjectModalComponent } from './modals/subject-modal/subject-modal.component';
import { ExamTypeModalComponent } from './modals/examtype-modal/examtype-modal.component';
//import { ExamComponent } from './modules/exam/exam.component';
// import { QuestionBankComponent } from './modules/question-bank/question-bank.component';
// import { AppSettingsComponent } from './modules/app-settings/app-settings.component';
import { ClassSetService } from './providers/class-set/class-set.service';
import { ExamtypeService } from './providers/examtype/examtype.service';
import { LevelService } from './providers/level/level.service';
import { QuestiondifficultyService } from './providers/questiondifficulty/questiondifficulty.service';
import { SubjectService } from './providers/subject/subject.service';
import { MatCardModule} from '@angular/material/card';
import { ClasssetModalComponent } from './modals/classset-modal/classset-modal.component';
// import { StudentComponent } from './modules/student/student.component';
import { ClassModalComponent } from './modals/class-modal/class-modal.component';
import { ExamModalComponent } from './modals/exam-modal/exam-modal.component';
import { StudentModalComponent } from './modals/student-modal/student-modal.component';
import { QuestionModalComponent } from './modals/question-modal/question-modal.component';
import { DifficultyModifierModalComponent } from './modals/difficulty-modifier-modal/difficulty-modifier-modal.component';
import { ClassStudentModalComponent } from './modals/class-student-modal/class-student-modal.component';


@NgModule({
  declarations: [
    AppComponent,
    SupervisorModalComponent,
    QuestionDifficultyModalComponent,
    LevelModalComponent,
    SubjectModalComponent,
    ExamTypeModalComponent,
    ClasssetModalComponent,
    ClassModalComponent,
    ExamModalComponent,
    StudentModalComponent,
    QuestionModalComponent,
    DifficultyModifierModalComponent,
    ClassStudentModalComponent
    // AppSettingsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    MatCardModule,
    BrowserAnimationsModule,
    DefaultModule,
    SharedModule,
    MatButtonModule,
    MatDialogModule,
    MatCheckboxModule,
    MatSelectModule,
    MatRadioModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    ModalModule.forRoot()
  ],
  providers: [ClassSetService, ExamtypeService, LevelService, QuestiondifficultyService, SubjectService],
  bootstrap: [AppComponent]
})
export class AppModule { }
